import * as actionTypes from '../types';
export const ScheduleTestDrivePageDetails = {
  state: {
    loading: false,
    showNoVehicleError: false,
    currentstep: 1,
    currentComponent: 'schedule-test-drive-step2',
    testDriveAtDealerShip: false,
    vehicleDetails: {},
    testDriveSettings: {},
    geoLocation: '',
    botDocData: '',
    formData: {
      firstName:
        window?.userDetails?.firstname ? window.userDetails.firstname : '',
      lastName:
        window?.userDetails?.lastname ? window.userDetails.lastname : '',
      email: window?.userDetails?.email ? window.userDetails.email : '',
      phone:
        window?.userDetails?.phonenumber ? window.userDetails.phonenumber : '',
      vehicle: '',
      dateTime: '',
      address: '',
      appraiseVehicle: true,
      testDriveLocation: '',
    },
  },
  getters: {
    [actionTypes.SCHEDULE_TEST_DRIVE_CURRENT_COMPONENT](state, payload) {
      if (state.currentstep === 1) {
        state.currentComponent = 'schedule-test-drive-step2';
      } else if (state.currentstep === 2) {
        state.currentComponent = 'schedule-test-drive-step3';
      } else if (state.currentstep === 3) {
        state.currentComponent = 'schedule-test-drive-step4';
      } else {
        // No action needed for other cases.
      }
      return state.currentComponent;
    },
    [actionTypes.SCHEDULE_TEST_DRIVE_VEHICLE_AS_PARAM](state, payload) {
      let vehicleConcatenation = `${state.vehicleDetails.type}/${state.vehicleDetails.vin}/${state.vehicleDetails.year}-${state.vehicleDetails.make}-${state.vehicleDetails.model}-${state.vehicleDetails.body}`;
      vehicleConcatenation = vehicleConcatenation.trim().toLowerCase().replace(' ', '-');
      return vehicleConcatenation;
    },
  },
  mutations: {
    [actionTypes.SET_SHOW_NO_VEHICLE_ERROR](state, payload) {
      state.showNoVehicleError = payload;
    },
    [actionTypes.INCREMENT_SCHEDULE_TEST_DRIVE_STEP](state, payload) {
      state.currentstep++;
    },
    [actionTypes.DECREMENT_SCHEDULE_TEST_DRIVE_STEP](state, payload) {
      state.currentstep--;
    },

    [actionTypes.SCHEDULE_TEST_DRIVE_AT_DEALERSHIP](state, payload) {
      state.testDriveAtDealerShip = payload;
    },

    [actionTypes.SCHEDULE_TEST_DRIVE_VEHICLE_DETAILS](state, payload) {
      state.vehicleDetails = payload;
      let vehicleName = `${state.vehicleDetails.year} ${state.vehicleDetails.make} ${state.vehicleDetails.model} ${state.vehicleDetails.trim}`;
      state.formData.vehicle = vehicleName;
    },

    [actionTypes.SCHEDULE_TEST_DRIVE_SET_LOADING](state, payload) {
      state.loading = payload;
    },
    [actionTypes.SCHEDULE_TEST_DRIVE_SET_ADDRESS_EMPTY](state, payload) {
      state.formData.emaddressail = '';
    },
    [actionTypes.SCHEDULE_TEST_DRIVE_SETTINGS](state, payload) {
      state.testDriveSettings = payload;
      state.formData.appraiseVehicle = state.testDriveSettings.autoToggleVehicleAppraisal;
    },
    [actionTypes.SCHEDULE_TEST_DRIVE_GEO_LOCATION](state, payload) {
      state.geoLocation = payload;
    },
    [actionTypes.SCHEDULE_TEST_DRIVE_BOTDOC_DATA](state, payload) {
      state.botDocData = payload;
    },
  },
};
